import React from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { Description } from '../../../components/Description';
import { useOfferContext } from '../../../context';
import { isSuburban } from '../../../utils/computedProps/category/isSuburban';
import { isCommercialMultiAds } from '../../../utils/computedProps/commercial/multiAds/isCommercialMultiAds';
import { isNewbuildingBookedFromDeveloper } from '../../../utils/newbuildingBooking';

export function DescriptionContainer() {
  const { offer, isNewbuildingFromDeveloper } = useOfferContext();
  const { config } = useApplicationContext();

  if (!offer.description || isCommercialMultiAds(offer)) {
    return null;
  }

  const isBookedFromDeveloper = isNewbuildingBookedFromDeveloper(offer);
  const isV2BookedFromDeveloperEnabled = config.get<boolean>('Newbuilding.BookedFromDeveloperDesktop.Enabled');
  const isCoworking = Boolean(offer.coworkingOfferType);
  const maxLines = isSuburban(offer) || isNewbuildingFromDeveloper ? 4 : 5;

  return (
    <Description
      lines={maxLines}
      text={offer.description}
      color={isBookedFromDeveloper && isV2BookedFromDeveloperEnabled ? 'text-secondary-default' : undefined}
      isCoworking={isCoworking}
    />
  );
}
